import FormulaireCalcule from "../views/FormulaireCalcule";
import LoginComponent from "../views/Login";

import Notifications from '@/views/notifications/Notifications.vue'

//solar
import PVGISform from '@/views/PVGIS/PVGISform.vue'
import results_PVGIS from '@/views/PVGIS/results_PVGIS.vue'
import SolarIndvPresentation from '@/views/PVGIS/pdfTemplates/presentationHTML/SolarIndvPresentation.vue'
import notFound from "../views/not-found";
import Vue from "vue";
import VueRouter from "vue-router";
import CookieService from "../services/cookie";
//solar collectif
import NouvelleOpportuniteSolarCollectif from '@/views/solarCollectif/nouvelleOpportuniteSolarCollectif.vue'
import validationDemandeCotationSolar from '@/views/solarCollectif/validationDemandeCotationSolar.vue'
import CotationSolarCollectif from '@/views/solarCollectif/cotationSolar/cotationSolar.vue'
import viewResultatSolarCollectif from '@/views/solarCollectif/cotationSolar/viewResultatSolarCollectif.vue'
import SolarCollectifPresentation from '@/views/solarCollectif/pdfTemplates/presentationHTML/SolarCollectifPresentation.vue'
import CalendarLayout from "@/layouts/CalendarLayout";
import DetailCompteurSolar from "../views/solarCollectif/DetailCompteurSolar.vue";

// get userRole from cookie
Vue.use(VueRouter);
const routes = [
  
  {
    path: "/login",
    component: LoginComponent,
    name: "Login",
  },
 


  // {
  //   path: '/solar',
  //   name: 'Solar-Calc',
  //   component: PVGISform,
  //   props: true,
  //   meta: {
  //     isLeftMenuItem: true,
  //     requiresAuth: true,
  //     icon: 'mdi-home',
  //     roles: ["admin", "superadmin", "ADV", "Chef équipe", "Prospecteur"],
  //   },
  // },
  {
    path: '/solar/resultat',
    name: 'results_PVGIS',
    component: results_PVGIS,
    props: true,
    meta: {
      isLeftMenuItem: false,
      requiresAuth: true,
      icon: 'mdi-home',
      roles: ["admin", "superadmin", "ADV", "Chef équipe", "Prospecteur"],
    },
  },
  {
    path: "/solar-indv-presentation/:token",
    component: SolarIndvPresentation,
    name: "Solar Individual Presentation",
  },
  {
    path: "/detail-compteur-Solar/:id",
    component: DetailCompteurSolar,
    name: "Detail Compteur",
    props: true,
    meta: {
      isLeftMenuItem: false,
      requiresAuth: true,
      roles: ["admin", "superadmin", "ADV", "Chef équipe", "chefIngenieur", "Prospecteur", "technicien", "ingenieur"],
      icon: "mdi-numeric",
    },
  },
 
{
  path: "/nouvelle-opportunite",
  component: NouvelleOpportuniteSolarCollectif,
  name: "Nouvelle Opportunité",
  meta: {
    isLeftMenuItem: true,
    requiresAuth: true,
    icon: "mdi-solar-power",
    roles: [
      "admin",
      "superadmin",
      "ADV",
      "Chef équipe",
      "technicien",
      "ingenieur",
      "Prospecteur"
    ],
  },
},
{
    path: "/validationDemandeCotationSolar",
    component: validationDemandeCotationSolar,
    name: "Validations de Cotations",
    meta: {
      isLeftMenuItem: true,
      requiresAuth: true,
      icon: "mdi-solar-power",
      roles: [
        "admin",
        "superadmin",
        "ADV",
        "Chef équipe",
        "technicien",
        "ingenieur",
        "Prospecteur"
      ],
    },
},
{
  path: "/CotationSolarCollectif",
  component: CotationSolarCollectif,
  name: "Cotation",
  meta: {
    isLeftMenuItem: true,
    requiresAuth: true,
    icon: "mdi-solar-power",
    roles: [
      "admin",
      "superadmin",
      "ADV",
      "Chef équipe",
      "technicien",
      "ingenieur",
      "Prospecteur"
    ],
  },
},


  
  {
    path: "/solar-collectif-presentation/:token",
    component: SolarCollectifPresentation,
    name: "Solar Collectif Presentation",
  },
  {
    path: "/SolarCollectif",
    component: CalendarLayout,
    name: "Solar Collectif",
    meta: {
      isLeftMenuItem: false,
      requiresAuth: true,
      icon: "mdi-solar-power",
      roles: [
        "admin",
        "superadmin",
        "ADV",
        "Chef équipe",
        "technicien",
        "ingenieur",
        "Prospecteur"
      ],
    },
    children: [
    
      {
        path: "viewResultatSolarCollectif/:id",
        component: viewResultatSolarCollectif,
        name: "Resultat Solar Collectif",
        meta: {
          isLeftMenuItem: false,
          icon: "mdi-calendar-cursor",
          roles: ["admin", "superadmin", "ADV", "Chef équipe", "Prospecteur"],
        },
      },
      

      
    ],
  },


  {
    path: "/formulaire-calcul",
    component: FormulaireCalcule,
    name: "Formulaire de Calcul",
    meta: {
      isLeftMenuItem: false,
      requiresAuth: true,
      roles: ["admin", "superadmin", "Prospecteur", "ADV", "Chef équipe"],
      icon: "mdi-calculator",
    },
  },
  //Infos Courbe de Charge

  //****************************************



  //notifications
  {
    path: "/notifications",
    component: Notifications,
    name: "Notifications",
    props: true,
    meta: {
      isLeftMenuItem: false,
      requiresAuth: true,
    },
  },

  // not found 404 link
  { path: "*", component: notFound, name: "not-found" },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  // get routes that require authentication
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  // check user authenticated or not
  const isAuthenticated = CookieService.checkCookie();
  // get the user's role.
  let userRole = null;
  const compte = CookieService.getCookie('compte');
  if (compte && Object.keys(compte).length>0) {
    const user = JSON.parse(compte)
    userRole = user.type;
  }
  
  if (requiresAuth && (!isAuthenticated || !userRole)) {
    // If the route requires authentication and the user is not logged in
    // Redirect the user to the home page or the login page.
    next('/login');
  } else if (requiresAuth && isAuthenticated && userRole) {
    // If the route requires authentication and the user is logged in
    const requiredRoles = to.meta.roles;
    if (!requiredRoles || requiredRoles.includes(userRole)) {
      console.log(to)
      // If the user's role matches the required roles for the route
      next(); // Allow access to the route
    } else {
      // Redirect to the home page if the user's role doesn't match the required roles.
      next('/');
    }
  } else {
    // For non-protected routes, simply proceed to the next route.
    if (to.path === "/") {
      next({ name: "Login" });
    } else if (to.path === "/login" && isAuthenticated) {
      next("/nouvelle-opportunite");
    } else {
      next();
    }
  }

});

export default router;
